import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../../../common/template/content';
import ContentCard from '../../../common/template/contentCard';
import ContentCardHeader from '../../../common/template/contentCardHeader';
import ContentCardBody from '../../../common/template/contentCardBody';
import Row from '../../../common/layout/row';
import Grid from '../../../common/layout/grid';
import Table from '../../../common/table/table';
import THead from '../../../common/table/tHead';
import Tr from '../../../common/table/tr';
import Th from '../../../common/table/th';
import TBody from '../../../common/table/tBody';
import Td from '../../../common/table/td';
import ButtonTable from '../../../common/table/buttonTable';
import Button from '../../../common/button/button';
import Form from './safraManejoInvasorForm';
import imagemSoLogo from '../../../assets/images/sologo.png';
import FormatUtils from '../../../common/formatUtils/FormatUtils';
import DateFormat from '../../../common/dateFormat/DateFormat';

import {
	setModoTela, initForm, salvar, excluir, getLista
} from './safraManejoInvasorActions';

class SafraManejoInvasor extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getLista(this.props.registroSafraManejo.id);
		this.props.setModoTela('lista');
    }

    render() {
        return (
            <div>

				{this.props.aguardando ? (
					<div class='modal fade show' id='modal-overlay' style={{ display: 'block', paddingRight: 15 }} aria-modal='true' role='dialog'>
						<div class='modal-dialog'>
							<div class='overlay'>
								<div style={{ marginLeft: '50%', marginRight: '50%' }}>
									<img src={imagemSoLogo} style={{ height: 40, width: 40, marginBottom: -76, marginLeft: 8 }} />
								</div>
								<i class='fas fa-4x fa-spinner fa-spin' style={{ marginLeft: '50%', marginRight: '50%' }}></i>
							</div>
						</div>
					</div>
				) : null}

                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		let doenca = false;
		let praga = false;
		let plantaInvasora = false;
		(this.props.registroSafraManejo.tipos || []).forEach(item => {
			if (this.props.listaTipo.filter(tipo => tipo.id == item && tipo.doenca).length > 0) {
				doenca = true;
			}
			if (this.props.listaTipo.filter(tipo => tipo.id == item && tipo.praga).length > 0) {
				praga = true;
			}
			if (this.props.listaTipo.filter(tipo => tipo.id == item && tipo.planta_invasora).length > 0) {
				plantaInvasora = true;
			}
		});


		return (
			<ContentCard>
				<ContentCardHeader>
					<label>Doenças / Insetos / Pragas / Plantas Invasoras</label>
				</ContentCardHeader>
				<ContentCardHeader>
					<Row>
						{doenca ? (
							<Grid cols='6 6 4 2'>
								<Button
									text='Adicionar Doença'
									type={'success'}
									icon={'fa fa-plus'}
									event={() => {
										this.props.setModoTela('cadastro', { id_safra_manejo: this.props.registroSafraManejo.id, doenca: true });
										this.props.initForm({ id_safra_manejo: this.props.registroSafraManejo.id });
									}} />
							</Grid>
						) : null}
						{praga ? (
							<Grid cols='6 6 4 2'>
								<Button
									text='Adicionar Inseto/Praga'
									type={'success'}
									icon={'fa fa-plus'}
									event={() => {
										this.props.setModoTela('cadastro', { id_safra_manejo: this.props.registroSafraManejo.id, praga: true });
										this.props.initForm({ id_safra_manejo: this.props.registroSafraManejo.id });
									}} />
							</Grid>
						) : null}
						{plantaInvasora ? (
							<Grid cols='6 6 4 2'>
								<Button
									text='Adicionar Planta Invasora'
									type={'success'}
									icon={'fa fa-plus'}
									event={() => {
										this.props.setModoTela('cadastro', { id_safra_manejo: this.props.registroSafraManejo.id, planta_invasora: true });
										this.props.initForm({ id_safra_manejo: this.props.registroSafraManejo.id });
									}} />
							</Grid>
						) : null}
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Tipo</Th>
								<Th>Nome</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.id_doenca ? 'Doença' : (item.id_praga ? 'Inseto/Praga' : 'Planta Invasora')}</Td>
									<Td>{item.nome_doenca || item.nome_praga || item.nome_planta_invasora}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													doenca: item.id_doenca ? true : false,
													praga: item.id_praga ? true : false,
													planta_invasora: item.id_planta_invasora ? true : false
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													doenca: item.id_doenca ? true : false,
													praga: item.id_praga ? true : false,
													planta_invasora: item.id_planta_invasora ? true : false
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.safraManejoInvasor.modoTela,
	lista: state.safraManejoInvasor.lista,
	listaTipo: state.safraManejo.listaTipo,
	aguardando: state.safraManejoInvasor.aguardando,
	registroSafraManejo: state.safraManejo.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SafraManejoInvasor);
